import flattenDeep from 'lodash/flatMapDeep';
import uniq from 'lodash/uniq';
import get from 'lodash/get';

import { SALE_TYPE, WAREHOUSE } from 'pages/constants';

export const getItemsCount = (shipments) =>
  shipments.reduce((itemsCount, shipment) => {
    const productsNum = shipment.products.reduce((result, product) => {
      if (product.productType === 'box') return result + 1;
      const itemsNum = product.items.reduce((productItemsCount, item) => {
        return productItemsCount + item.quantity;
      }, 0);
      return result + itemsNum;
    }, 0);
    return itemsCount + productsNum;
  }, 0);

export const getSaleTypes = (shipments) => {
  const keys = shipments.map((shipment) => shipment.products.map((product) => product.productType));
  const flattenKeys = flattenDeep(keys);
  const uniqueKeys = uniq(flattenKeys);
  const types = uniqueKeys.map((key) => get(SALE_TYPE, key, ''));
  const saleTypes = types.filter((type) => type);
  return saleTypes.join(', ');
};

export const getSaleType = (shipment) => {
  const keys = shipment.products.map((product) => product.productType);
  const types = keys.map((key) => get(SALE_TYPE, key, ''));
  const saleTypes = types.filter((type) => type);
  return saleTypes.join(', ');
};

export const getShipped = (shipments) =>
  shipments.filter(
    (shipment) =>
      shipment.shipmentDetails &&
      shipment.shipmentDetails.warehouse !== WAREHOUSE.envista &&
      shipment.shipmentDetails.warehouse !== WAREHOUSE.enspire,
  );

export const getPending = (shipments) => shipments.filter((shipment) => !shipment.shipmentDetails);

export const getDropship = (shipments) =>
  shipments.filter(
    (shipment) =>
      shipment.shipmentDetails &&
      (shipment.shipmentDetails.warehouse === WAREHOUSE.envista ||
        shipment.shipmentDetails.warehouse === WAREHOUSE.enspire),
  );

export const getTotalProducts = (shipments) =>
  shipments.reduce((result, shipment) => {
    return result + shipment.products.length;
  }, 0);

const shippingCarriers = {
  FedEx: (trackingNumber) => `https://www.fedex.com/fedextrack/?trknbr=${trackingNumber}`,
  USPS: (trackingNumber) =>
    `https://tools.usps.com/go/TrackConfirmAction_input?qtc_tLabels1=${trackingNumber}`,
  Landmark: (trackingNumber) => `https://track.landmarkglobal.com/?trck=${trackingNumber}`,
  OnTrac: (trackingNumber) => `https://www.ontrac.com/tracking/?number=${trackingNumber}`,
  'Pitney Bowes': (trackingNumber) => `https://pitneybowes.shipment.co/track/${trackingNumber}`,
  LaserShip: (trackingNumber) => `https://lasership.com/track/${trackingNumber}`,
  DHLJ: (trackingNumber) => `https://webtrack.dhlecs.com/?trackingnumber=${trackingNumber}`,
  'DHL eCommerce': (trackingNumber) =>
    `https://webtrack.dhlecs.com/?trackingnumber=${trackingNumber}`,
  GHLR: (trackingNumber) =>
    `https://ghl.sprinttek.com/account/tracking-page-order-detail/${trackingNumber}/true`,
  'Grand Husky Logistics': (trackingNumber) =>
    `https://ghl.sprinttek.com/account/tracking-page-order-detail/${trackingNumber}/true`,
};

export const getTrackingUrl = (carrier, trackingNumber) => {
  if (!carrier || !trackingNumber) return null;
  const getUrl = get(shippingCarriers, carrier, () => null);
  return getUrl(trackingNumber);
};
